export const PACKING_READY_FOR_PACKING = 'PACKING_READY_FOR_PACKING';
export const PACKING_IN_PROCESS = 'PACKING_IN_PROCESS';
export const PACKING_COMPLETED = 'PACKING_COMPLETED';
export const PACKING_RETURNED = 'PACKING_RETURNED';
export const PACKING_CANCELED = 'PACKING_CANCELED';
export const PACKING_DELIVERED = 'PACKING_DELIVERED';
export const PACKING_DISPATCHED = 'PACKING_DISPATCHED';
